import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { PrismButton } from '@mylighthouse/prism-ember';
import { ICONS_LOGOS_MAP } from '@mylighthouse/prism-foundation';
import { t } from 'ember-intl';
import { FocusScreen, TickSlider } from 'frontend-utils';
import SmartCompsetBuilderWeightsIllustration from 'lumen/assets/images/benchmark-insight/smart-compset/beni-smart-compset-builder-weights.svg?raw';
import HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooter from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/smart-compset-builder/smart-compset-builder-footer';
import HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderHeader from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/smart-compset-builder/smart-compset-builder-header';
import HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderInfo from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/smart-compset-builder/smart-compset-builder-info';
import type HotelSettingsCompetitorsBenchmarkSmartCompsetWeightsController from 'lumen/controllers/hotel/settings/competitors/benchmark/smart-compset/weights';

interface HotelSettingsCompetitorsBenchmarkSmartCompsetWeightsSignature {
  Args: {
    controller: HotelSettingsCompetitorsBenchmarkSmartCompsetWeightsController;
    model: unknown;
  };
}

<template>
  <FocusScreen
    @hasCancel={{true}}
    @isCancelDisabled={{false}}
    @logoHtml={{ICONS_LOGOS_MAP.logo-dark-with-text}}
    @onClose={{@controller.onCloseModal}}
    @size="large"
  >
    <:header>
      <HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderHeader
        @currentStep={{2}}
      />
    </:header>

    <:body>
      <div
        class="smart-compset__builder__body smart-compset__builder__body--weights"
      >
        <div
          class="smart-compset__builder__body__left smart-compset__builder__body__left--weights"
        >
          <HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderInfo
            @imageHtml={{SmartCompsetBuilderWeightsIllustration}}
            @subTitle={{t
              "benchmark-insight.smart-compset.smart-compset-builder.sub-title.weights"
            }}
            @title={{t
              "benchmark-insight.smart-compset.smart-compset-builder.title.weights"
            }}
          />
        </div>
        <div class="smart-compset__builder__body__right">
          <div
            class="smart-compset__builder__body__right__content__weights--container"
          >

            <div class="smart-compset__builder__body__right__content__weights">
              {{#each @controller.categories as |category|}}
                <div
                  class="smart-compset__builder__body__right__content__weights__weight flex flex-col"
                >
                  <p
                    class="smart-compset__builder__body__right__content__weights__weight__label heading-4"
                  >{{category.formattedName}}</p>

                  <TickSlider
                    @max={{5}}
                    @min={{1}}
                    @onInput={{fn @controller.onInput category}}
                    @step={{1}}
                    @value={{category.weight}}
                  />

                  <div
                    class="smart-compset__builder__body__right__content__weights__weight__tick-labels mt-100"
                  >
                    {{#each @controller.tickLabels as |tickLabel|}}
                      <div
                        class="smart-compset__builder__body__right__content__weights__weight__tick-labels__tick-label text-200--regular"
                      >
                        <span>{{tickLabel}}</span>
                      </div>
                    {{/each}}
                  </div>
                </div>
              {{/each}}
            </div>
          </div>

        </div>
      </div>
    </:body>

    <:footer>
      <HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooter
      >

        <span class="smart-compset__builder__footer--back">
          <PrismButton
            @buttonType="ghost"
            @iconBefore="arrow-left"
            @label={{t "general.back"}}
            @onClick={{@controller.onBack}}
          />
        </span>

        <span class="smart-compset__builder__footer--continue">
          <PrismButton
            @buttonType="brand"
            @iconAfter="arrow-right"
            @label={{t "general.continue"}}
            @onClick={{@controller.onContinue}}
            data-test-id="smart-compset-weights-button-continue"
          />
        </span>
      </HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooter>
    </:footer>
  </FocusScreen>
</template> satisfies TOC<HotelSettingsCompetitorsBenchmarkSmartCompsetWeightsSignature>;
